module.exports = __webpack_public_path__ + "static/media/mc_settings_button_icon.df280cbc.svg";